import { combineReducers } from "@reduxjs/toolkit";
import { findFederatedReducer } from "./findFederatedReducer";
import { alertReducer } from "./alertReducer";
import { findRpUrlsReducer } from "./findRpUrls";
import { accountNotificationReducer } from "./accountNotificationReducer";
import { wechatLoginReducer } from "./weChatEmailCheckReducer";


export default combineReducers({
    alertReducer: alertReducer,
    findFederatedReducer: findFederatedReducer,
    findRpUrlsReducer: findRpUrlsReducer,
    accountNotificationReducer:accountNotificationReducer,
    wechatLoginReducer: wechatLoginReducer,
});
